exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-flows-deal-status_transitions-components-DealClosedConfirmation-___style__header___2r4gA{display:flex;justify-content:space-between;border-bottom:1px solid #e5e3e3}.web-flows-deal-status_transitions-components-DealClosedConfirmation-___style__h2___2jYDV{border-bottom:none!important}.web-flows-deal-status_transitions-components-DealClosedConfirmation-___style__close___13Rpa{padding:0 .7em .7em 0}@media (min-width:599px){.web-flows-deal-status_transitions-components-DealClosedConfirmation-___style__content___2GYOU{width:600px}}@media (max-width:599px){.web-flows-deal-status_transitions-components-DealClosedConfirmation-___style__toplevel___2HBwX{padding:1em .5em 0}}.web-flows-deal-status_transitions-components-DealClosedConfirmation-___style__error___39wtG{color:#2d62b7;font-weight:700}", ""]);

// exports
exports.locals = {
	"header": "web-flows-deal-status_transitions-components-DealClosedConfirmation-___style__header___2r4gA",
	"h2": "web-flows-deal-status_transitions-components-DealClosedConfirmation-___style__h2___2jYDV",
	"close": "web-flows-deal-status_transitions-components-DealClosedConfirmation-___style__close___13Rpa",
	"content": "web-flows-deal-status_transitions-components-DealClosedConfirmation-___style__content___2GYOU",
	"toplevel": "web-flows-deal-status_transitions-components-DealClosedConfirmation-___style__toplevel___2HBwX",
	"error": "web-flows-deal-status_transitions-components-DealClosedConfirmation-___style__error___39wtG"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/flows/deal/status_transitions/components/DealClosedConfirmation/style.css
// module id = 1348
// module chunks = 0